import { useEffect, useRef } from "react";

/**
 * This hook provides the value of previous and the latest ref when ref changes in runtime
 *
 * USAGE:
 *
 * useRefWatcher(dotCarouselRef, (previousValue, currentValue) => {
    any calculation or state changes required
  })
 *
 * Benefit: It is used to get properties of the ref like width, height etc in runtime if ref changes,
 *  and update the state if required, because ref won't re-render the UI.
 *
 **/

export const useRefWatcher = (ref, callback) => {
  const previousValue = useRef(ref.current);

  useEffect(() => {
    if (previousValue != ref || previousValue.current !== ref.current) {
      callback(previousValue.current, ref.current);
      previousValue.current = ref.current;
    }
  }, [ref, ref.current, callback]);
};
